import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { BookOpen, Gift, Check } from 'lucide-react';
export function OfferSection() {
  const bonuses = [{
    title: 'Plan de Comidas Cero Inflamación',
    desc: 'Recetas deliciosas de 15 min.',
    value: '$97'
  }, {
    title: 'Guía de Suplementación Estratégica',
    desc: 'Qué tomar para los sofocos y el ánimo.',
    value: '$97'
  }, {
    title: 'Guía del Sueño Reparador',
    desc: 'El secreto para quemar grasa mientras duermes.',
    value: '$67'
  }, {
    title: 'Lista de Compras Anti-Niebla Mental',
    desc: 'Recupera tu foco y memoria.',
    value: '$47'
  }];
  return <section id="oferta" className="py-24 px-4 bg-white" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <div className="text-center mb-12" data-id="element-136">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-dark mb-6" data-id="element-137">
            Todo lo que recibes hoy al unirte a<br data-id="element-138" />
            <span className="text-sage-dark italic" data-id="element-139">
              "El Código Hormonal 40+"
            </span>
          </h2>
        </div>

        <div className="bg-cream-dark rounded-3xl p-8 md:p-12 shadow-xl border border-gold/20 relative overflow-hidden" data-id="element-140">
          {/* Main Product */}
          <div className="flex items-start gap-4 mb-8 pb-8 border-b border-sage/20" data-id="element-141">
            <div className="bg-sage p-3 rounded-xl text-white shrink-0" data-id="element-142">
              <BookOpen className="w-6 h-6" data-id="element-143" />
            </div>
            <div data-id="element-144">
              <h3 className="font-bold text-xl text-dark mb-1" data-id="element-145">
                Ebook Principal: El Código Hormonal 40+
              </h3>
              <p className="text-dark-light" data-id="element-146">
                El protocolo de 21 días paso a paso.
              </p>
              <p className="text-sm font-bold text-sage-dark mt-2" data-id="element-147">
                Valor: $197
              </p>
            </div>
          </div>

          {/* Bonuses */}
          <div className="space-y-6 mb-12" data-id="element-148">
            <h4 className="font-heading font-bold text-xl text-dark flex items-center gap-2" data-id="element-149">
              <Gift className="w-5 h-5 text-gold" data-id="element-150" />
              Bonos de Acción Rápida Incluidos:
            </h4>

            {bonuses.map((bono, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-3 bg-white p-4 rounded-xl border border-sage/10" data-id="element-151">
                <Check className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-152" />
                <div className="flex-1" data-id="element-153">
                  <p className="font-bold text-dark" data-id="element-154">{bono.title}</p>
                  <p className="text-sm text-dark-light" data-id="element-155">{bono.desc}</p>
                </div>
                <div className="text-sm font-bold text-sage-dark shrink-0" data-id="element-156">
                  Valor: {bono.value}
                </div>
              </motion.div>)}
          </div>

          {/* Pricing */}
          <div id="precio" className="bg-white rounded-2xl p-8 text-center border-2 border-gold border-dashed mb-8" data-id="element-157">
            <p className="text-dark-light mb-2" data-id="element-158">
              VALOR TOTAL:{' '}
              <span className="line-through text-urgency font-bold" data-id="element-159">
                $505.00
              </span>
            </p>
            <p className="text-sm font-bold text-sage-dark uppercase tracking-widest mb-2" data-id="element-160">
              Precio Especial Hoy
            </p>
            <div className="font-heading text-6xl md:text-7xl font-bold text-dark mb-6" data-id="element-161">
              $37<span className="text-2xl text-dark-light" data-id="element-162">.00</span>
            </div>
            <Button onClick={() => document.getElementById('cta-final')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} className="w-full md:w-auto text-xl py-5 px-10" data-id="element-163">
              SÍ, QUIERO RECUPERAR MI CUERPO
            </Button>
            <p className="text-sm text-dark-light mt-4" data-id="element-164">
              Pago 100% seguro y encriptado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}